<script setup lang="ts">
import type { DialogOverlayProps } from "reka-ui"
import type { HTMLAttributes } from "vue"
import { reactiveOmit } from "@vueuse/core"
import { DialogOverlay } from "reka-ui"
import { cn } from "@/lib/utils"

const props = defineProps<DialogOverlayProps & { class?: HTMLAttributes["class"] }>()

const delegatedProps = reactiveOmit(props, "class")
</script>

<template>
  <DialogOverlay
    data-slot="dialog-overlay"
    v-bind="delegatedProps"
    :class="cn('data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 fixed inset-0 z-50 bg-black/80', props.class)"
  >
    <slot />
  </DialogOverlay>
</template>

<style scoped>
/* Лёгкое размытие фона под модалкой. iOS PWA: нужен -webkit-префикс — Tailwind 4
   его не добавляет; где backdrop-filter не поддержан, остаётся затемнение bg-black/80. */
[data-slot='dialog-overlay'] {
  -webkit-backdrop-filter: blur(3px);
  backdrop-filter: blur(3px);
}
</style>
